<!--
 * @Author: 裴纬华
 * @Date: 2021-08-19 16:00:52
 * @LastEditors: 裴纬华
 * @LastEditTime: 2021-12-28 13:45:22
 * @Description: content
-->
<template>
  <div :class="preClass">
    <p class="my-table-title" v-if="title">{{title}}</p>
    <table >
      <thead v-if="headers.length">
            <tr>
              <th v-for="item in headers" :key="item">{{item}}</th>
            </tr>
        </thead>
      <tbody  v-if="data.length">
        <template v-for="(item,index) in data">
            <template v-if="item.valueType==='table'">
              <tr  :key="item.title+'1'" > <td class="tr-title" colspan="2" align='center'>{{item.title}}</td></tr>
                <tr class="tr-table" align='center' v-if="item.topThirdData" :key="item.title+'2'">
                  <td  colspan="2"><base-table :data="item.topThirdData"></base-table></td>
                </tr>
            </template>
            <template v-else-if="item.valueType==='tips'">
              <tr  :key="item.title+'1'" > <td class="tr-title" colspan="2" align='center' style="color:red">*{{item.tips}}</td></tr>
            </template>
            <template v-else>
                <tr   :key="item.title" v-if="item.maxRow?index<item.maxRow:true">
                  <td @click="item.click?item.click():null" :style="{'text-align':item.align==='around'?'left':'right'}">{{ item.title}}</td>
                  <td @click="item.click?item.click(item,index):null" :style="{'text-align':item.align==='around'?'right':'left',color:item.color}">     <span v-if="item.filter">{{ Filters[item.filter]( item.value)}}</span> <span v-else>{{ item.value}}</span></td>
                  <td v-if="item.value2!==undefined" @click="item.click?item.click(item,index):null" :style="{'text-align':item.align==='around'?'right':'left',color:item.color}">     <span v-if="item.filter">{{ Filters[item.filter]( item.value2)}}</span> <span v-else>{{ item.value2}}</span></td>
                </tr>
              </template>
        </template>
      </tbody>
      <tbody v-else  >
              <tr> <td class="tr-title" :colspan="headers.length?headers.length: 2" align='center'>暂无数据</td></tr>
      </tbody>
     </table>

  </div>
</template>

<script>
export default {
  data() {
    return {
      preClass: "my-table"
    };
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    title:String
  }
};
</script>

<style lang="less">
.my-table {
  margin-top: 15px;
  &-title{
    background: #eee;
    padding: 10px;
    margin-top: 10px;
  }
    table{
        width: 100%;
        font-size: 12px;
        border-collapse:collapse;

        th,td{
            padding: 5px 8px;
            min-width: 50px;
            line-height: 18px;
        }
        thead{
          background: #eee;
        }
        .tr-title{
          font-size: 14px;
          padding: 10px;
        }
        .tr-table{
          text-align: right;
          .my-table{
            width: 100%;
          }
          table{
            width: 100%;
          }
        }
    }
      table,table tr th, table tr td { border:1px solid #ccc; }

}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseTable.vue